import type { Entity } from '@backstage/catalog-model';

import { useState } from 'react';

const shuffle = <T extends Entity>(entities: T[]) => {
  const shuffled = [...entities];
  for (let index = shuffled.length - 1; index > 0; index--) {
    const target = Math.floor(Math.random() * (index + 1));
    const entity = shuffled[index];
    const replacement = shuffled[target];
    if (entity && replacement) {
      shuffled[index] = replacement;
      shuffled[target] = entity;
    }
  }
  return shuffled;
};

export const useShuffledEntities = <T extends Entity>(entities?: T[]) => {
  const [snapshot, setSnapshot] = useState(() => ({
    entities,
    ordered: shuffle(entities ?? []),
  }));

  if (snapshot.entities !== entities) {
    const changed = JSON.stringify(snapshot.entities) !== JSON.stringify(entities);
    const next = {
      entities,
      ordered: changed ? shuffle(entities ?? []) : snapshot.ordered,
    };
    setSnapshot(next);
    return next.ordered;
  }

  return snapshot.ordered;
};
